import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';

import cn from 'classnames';

import { Text } from '@notino/react-styleguide';

import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';
import { typographyClass } from '@styles/common';

import {
  Item,
  Items,
  SelectOption,
  SelectValue,
  StyledDropdown,
  VariantLabelText,
  Wrapper,
} from './styled';
import { VariantGroup } from './useVariantGroups';

export const VariantGrouping = () => {
  const navigate = useNavigate();
  const { groups, selectedGroup, showGroups, getNavigationVariant } =
    useProductDetailContext().variantGroups;

  if (!showGroups) {
    return null;
  }

  const component =
    groups.length < 4 ? (
      <Items>
        {groups.map((group) => (
          <Item
            key={group.key}
            to={getNavigationVariant(group).url ?? ''}
            isSelected={group.key === selectedGroup?.key}
          >
            {group.name}
          </Item>
        ))}
      </Items>
    ) : (
      <StyledDropdown
        options={groups}
        selectedKey={selectedGroup?.key ?? ''}
        onSelect={(val) => navigate(getNavigationVariant(val).url ?? '')}
        renderOption={(val, selected) => (
          <SelectOption
            to={getNavigationVariant(val).url ?? ''}
            className={cn({
              [typographyClass.labelRegular]: selected,
              [typographyClass.labelRegular400]: !selected,
            })}
          >
            {val.name}
          </SelectOption>
        )}
        renderSelected={(val) => <SelectValue>{val?.name}</SelectValue>}
        mobileNativeSelectConfig={{ getLabel: (val: VariantGroup) => val.name }}
      />
    );

  return (
    <Wrapper>
      <Text typography="labelRegular400" color="common.gray30">
        <FormattedMessage
          id="pd.variantGrouping.package"
          defaultMessage="Baleni:"
        />
      </Text>

      {component}

      <VariantLabelText>
        <FormattedMessage
          id="pd.variantGrouping.variant"
          defaultMessage="Varianta:"
        />
      </VariantLabelText>
    </Wrapper>
  );
};
